// extracted by mini-css-extract-plugin
export var attachButton = "_c5-8";
export var sendButton = "_c5-2";
export var sendDisabled = "_c5-4";
export var sendEnabled = "_c5-3";
export var sendIcon = "_c5-6";
export var sendIconDisabled = "_c5-7";
export var sendStreaming = "_c5-5";
export var textarea = "_c5-1";
export var wrapper = "_c5-0";